import React from "react";
import styled, { css } from "styled-components";
import { color } from "../templates/ui";
import Cross from "../atoms/icons/Cross";
const ModalWrapper = styled.div `
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 100;

    @media only screen and (min-width: 992px) {
        align-items: center;
    }
`;
const Backdrop = styled.div `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.75);
    opacity: ${(props) => (props.showModal ? "1" : "0")};
    pointer-events: ${(props) => (props.showModal ? "auto" : "none")};
    transition: all 0.15s ease-in-out;
`;
const ModalContainer = styled.div `
    position: relative;
    background-color: ${color.body.base};
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.1);
    z-index: 101;
    border-radius: 10px;
    width: 100%;
    max-width: calc(100% - 20px);
    margin: 10px;
    height: auto;
    pointer-events: auto;

    @media only screen and (min-width: 992px) {
        max-width: ${(props) => (props.isExpanded ? "1050px" : "650px")};
    }

    @media only screen and (max-width: 991px) {
        transform: translate(0, 200%) !important;
        transition: all 0.15s ease-in-out;
        ${(props) => props.showModal &&
    css `
                transform: translate(0, 0) !important;
            `};
    }

    @media only screen and (min-width: 992px) {
        transform: scale(0);
        transition: all 0.15s ease-in-out;
        ${(props) => props.showModal &&
    css `
                transform: scale(1) !important;
            `};
    }
`;
const ModalCloseButton = styled.button `
    position: absolute;
    top: 15px;
    right: 15px;
    outline: none;
    padding: 11px;
    cursor: pointer;
    border: 2px solid #ff8300;
    background-color: #ff8300;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    transition: all 100ms ease-in-out;

    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 10px;
        height: 10px;
        fill: white;
    }
`;
const ModalContent = styled.div `
    padding: 35px;
    border-radius: 10px;
    overflow: hidden;
`;
export const ModalHeader = styled.div `
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    user-select: none;

    @media only screen and (min-width: 768px) {
        font-size: 20px;
    }

    @media only screen and (min-width: 992px) {
        margin-bottom: 30px;
    }
`;
export const ModalBody = styled.div ``;
export const ModalFooter = styled.div `
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;
const Modal = ({ showModal, isExpanded, children, onClose, }) => (React.createElement(ModalWrapper, null,
    React.createElement(ModalContainer, { showModal: showModal, isExpanded: isExpanded },
        React.createElement(ModalCloseButton, { onClick: onClose },
            React.createElement(Cross, null)),
        React.createElement(ModalContent, null, children)),
    React.createElement(Backdrop, { showModal: showModal, onClick: onClose })));
export default Modal;
